import { useForm } from 'react-hook-form';

import { zodResolver } from '@hookform/resolvers/zod';

import { z } from 'zod';

import { usePostChangePwApi } from '@/api/auth';
import Field from '@/components/common/Field/Field';
import InputText from '@/components/common/Input/InputText/InputText';
import { useToastStore } from '@/store/toastStore';

import * as S from './style';

interface RegisterField {
	originalPassword: string;
	password: string;
	passwordCheck: string;
}

const ModifyPassword = () => {
	const { openToast } = useToastStore();

	const userRegisterSchema = z
		.object({
			originalPassword: z.string().min(1, { message: '기존 비밀번호를 입력해 주세요.' }),
			password: z
				.string()
				.min(1, { message: '6~20자의 영문, 숫자,특수문자만 입력 가능합니다.' })
				.min(6, { message: '6~20자의 영문, 숫자,특수문자만 입력 가능합니다.' })
				.max(20, { message: '6~20자의 영문, 숫자,특수문자만 입력 가능합니다.' })
				.regex(/^[A-Za-z0-9!@#$%^&*()-_+=]+$/, { message: '6~20자의 영문, 숫자,특수문자만 입력 가능합니다.' }),
			passwordCheck: z.string().min(1, { message: '비밀번호가 일치하지 않습니다.' }),
		})
		.refine((data) => data.password === data.passwordCheck, {
			message: '비밀번호가 일치하지 않습니다.',
			path: ['passwordCheck'],
		});

	const {
		register,
		handleSubmit,
		watch,
		formState: { errors },
	} = useForm<RegisterField>({
		resolver: zodResolver(userRegisterSchema),
		mode: 'onChange',
		defaultValues: {
			originalPassword: '',
			password: '',
			passwordCheck: '',
		},
	});

	const { mutateAsync: changePw } = usePostChangePwApi();

	const onSubmit = async () => {
		const res = await changePw({
			member_new_password: watch('password'),
			member_original_password: watch('originalPassword'),
		});
		if (res.data.success) {
			openToast({
				subContent: '대한화장품학회',
				content: '정보가 변경되었습니다.',
			});
		} else {
			if (res.data.error.code === '90') {
				openToast({
					subContent: '대한화장품학회',
					content: '기존 비밀번호가 일치하지 않습니다.',
				});
			}
		}
	};

	return (
		<S.FormContainer onSubmit={handleSubmit(onSubmit)}>
			<S.FieldBox>
				<S.Title>비밀번호 변경</S.Title>
				<Field title="기존 비밀번호" error={errors.originalPassword?.message ?? ''}>
					<InputText isError={!!errors.originalPassword} type="password" placeholder="기존 비밀번호 입력" {...register('originalPassword')} />
				</Field>
				<Field title="새 비밀번호" error={errors.password?.message ?? ''}>
					<InputText type="password" isError={!!errors.password} placeholder="6~20자의 영문, 숫자,특수문자" {...register('password')} />
				</Field>
				<Field title="새 비밀번호 확인" error={errors.passwordCheck?.message ?? ''}>
					<InputText type="password" isError={!!errors.passwordCheck} {...register('passwordCheck')} placeholder="비밀번호 재입력" />
				</Field>
			</S.FieldBox>
			<S.NextButton type="submit">변경완료</S.NextButton>
		</S.FormContainer>
	);
};

export default ModifyPassword;
